import axios, { type AxiosInstance, AxiosResponse } from 'axios';

import config from ':cloud/config';
import { mapKeysToCamelCase } from ':cloud/utils/common';

const SHARED_API_SETTINGS = {
  headers: {
    'content-type': 'application/json',
  },
  withCredentials: true,
};

// used for resource manager endpoints
export const APIClient = axios.create({
  baseURL: config.resourceManagerServer,
  ...SHARED_API_SETTINGS,
});

// used for general cloud bridge endpoints, base URL = API_BASE_URL i.e. https://cloud-bridge-dev.cbhq.net
export const APIClientBase: AxiosInstance = axios.create({
  baseURL: config.apiBaseURL,
  ...SHARED_API_SETTINGS,
});

APIClientBase.interceptors.response.use((response) =>
  mapKeysToCamelCase<AxiosResponse<any, any>>(response),
);

export const PortfolioAPIClientBase: AxiosInstance = axios.create({
  baseURL: config.apiPortfolioURL,
  ...SHARED_API_SETTINGS,
});

/**
 * FOR LEGACY COMS READ RESPONSES ONLY
 *
 * Every COMS read endpoint has a legacyResponse field that contains the old
 * RM response shape alongside the new data shape in the main object. This
 * can be used to migrate in multiple phases.
 *
 * For all COMS write endpoints or any COMS read endpoints that use the NEW
 * data shapes, use APIClientBase.
 */
export const APIClientCOMSLegacy: AxiosInstance = axios.create({
  baseURL: config.apiBaseURL,
  ...SHARED_API_SETTINGS,
});

type COMSResponse = {
  [key: string]: any;
  legacyResponse: any;
};

APIClientCOMSLegacy.interceptors.response.use((response: AxiosResponse<COMSResponse>) => {
  const { legacyResponse } = response.data;
  const camelCaseResponse = mapKeysToCamelCase<AxiosResponse<any>>(legacyResponse);
  return { ...response, data: camelCaseResponse };
});

export const APIClientBaseRPC: AxiosInstance = axios.create({
  baseURL: config.developerAPIURL,
  ...SHARED_API_SETTINGS,
});

export const APIClientFaucet: AxiosInstance = axios.create({
  baseURL: config.apiBaseURL,
  ...SHARED_API_SETTINGS,
});
